/*
 * Enum for DLS breakpoints.
 * This absolutely should not be used unless you are specifically matching unchangeable DLS styling.
 */
export enum DLSBreakpoints {
    SMALL = 375,
    MEDIUM = 768
}
